import { defineStore } from 'pinia';
import { AdminSandpitVisibility } from '@/lib/stores/SandpitStore';

const LOCAL_STORAGE_FILTER_KEY: string = 'BOARD_OPTIONS.FILTER';
const STICKY_SHOW_EMPTY_LOCATIONS: boolean = false;

export interface BoardFilterState {
    showEmptyLocations: boolean;
    showShadowTasks: boolean;
    showAdhocTaskGroupsAsGrouped: boolean;
}


export const useBoardOptions = defineStore('boardOptions', {
    state: () => {
        return {
            boardFilterState: {
                showEmptyLocations: true,
                showShadowTasks: false,
                showAdhocTaskGroupsAsGrouped: true,
            } as BoardFilterState,
        };
    },
    getters: {
        defaultFilterState(): BoardFilterState {
            return {
                showEmptyLocations: true,
                showShadowTasks: true,
                showAdhocTaskGroupsAsGrouped: true,
            };
        },
        showEmptyLocations(): boolean {
            return this.boardFilterState.showEmptyLocations;
        },
        showShadowTasks(): boolean {
            return this.boardFilterState.showShadowTasks;
        },
        showAdhocTaskGroupsAsGrouped(): boolean {
            return this.boardFilterState.showAdhocTaskGroupsAsGrouped;
        }
    },
    actions: {
        setUpStore(){
              const savedFilterSettings = localStorage.getItem(LOCAL_STORAGE_FILTER_KEY);
                if (savedFilterSettings) {
                    const parsedFilterSettings = JSON.parse(savedFilterSettings);
                    if(!STICKY_SHOW_EMPTY_LOCATIONS)
                        parsedFilterSettings.showEmptyLocations = true;
                    this.boardFilterState = { ... this.defaultFilterState, ... parsedFilterSettings};
                } else {
                    this.boardFilterState = this.defaultFilterState;
                }
        },
        setShowEmptyLocations(showEmptyLocations: boolean): void {
            this.boardFilterState.showEmptyLocations = showEmptyLocations;
            this.saveFilterSettings();
        },
        setShowShadowTasks(showShadowTasks: boolean): void {
            this.boardFilterState.showShadowTasks = showShadowTasks;
            this.saveFilterSettings();
        },
        setShowAdhocTaskGroupsAsGrouped(showAdhocTaskGroupsAsGrouped: boolean): void {
            this.boardFilterState.showAdhocTaskGroupsAsGrouped = showAdhocTaskGroupsAsGrouped;
            this.saveFilterSettings();
        },
        saveFilterSettings(): void {
            localStorage.setItem(LOCAL_STORAGE_FILTER_KEY, JSON.stringify(this.boardFilterState));
        }
    }
})